var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#335CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 14H28.2C31.4 14 34 16.6 34 19.8V28.2C34 29.7383 33.3889 31.2135 32.3012 32.3012C31.2135 33.3889 29.7383 34 28.2 34H19.8C16.6 34 14 31.4 14 28.2V19.8C14 18.2617 14.6111 16.7865 15.6988 15.6988C16.7865 14.6111 18.2617 14 19.8 14ZM19.6 16C18.6452 16 17.7295 16.3793 17.0544 17.0544C16.3793 17.7295 16 18.6452 16 19.6V28.4C16 30.39 17.61 32 19.6 32H28.4C29.3548 32 30.2705 31.6207 30.9456 30.9456C31.6207 30.2705 32 29.3548 32 28.4V19.6C32 17.61 30.39 16 28.4 16H19.6ZM29.25 17.5C29.5815 17.5 29.8995 17.6317 30.1339 17.8661C30.3683 18.1005 30.5 18.4185 30.5 18.75C30.5 19.0815 30.3683 19.3995 30.1339 19.6339C29.8995 19.8683 29.5815 20 29.25 20C28.9185 20 28.6005 19.8683 28.3661 19.6339C28.1317 19.3995 28 19.0815 28 18.75C28 18.4185 28.1317 18.1005 28.3661 17.8661C28.6005 17.6317 28.9185 17.5 29.25 17.5ZM24 19C25.3261 19 26.5979 19.5268 27.5355 20.4645C28.4732 21.4021 29 22.6739 29 24C29 25.3261 28.4732 26.5979 27.5355 27.5355C26.5979 28.4732 25.3261 29 24 29C22.6739 29 21.4021 28.4732 20.4645 27.5355C19.5268 26.5979 19 25.3261 19 24C19 22.6739 19.5268 21.4021 20.4645 20.4645C21.4021 19.5268 22.6739 19 24 19ZM24 21C23.2044 21 22.4413 21.3161 21.8787 21.8787C21.3161 22.4413 21 23.2044 21 24C21 24.7956 21.3161 25.5587 21.8787 26.1213C22.4413 26.6839 23.2044 27 24 27C24.7956 27 25.5587 26.6839 26.1213 26.1213C26.6839 25.5587 27 24.7956 27 24C27 23.2044 26.6839 22.4413 26.1213 21.8787C25.5587 21.3161 24.7956 21 24 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ac6e8f100cc2f4d5bbf74567a8236e8b.svg";
export { ForwardRef as ReactComponent };